export default {
    state: {
        // shape item
        vipSymbolMark: false, // 页面是否含有vip符号
        vipTemplateMark: false, // 页面是否含有vip模板付费形状
        cummunityVipTemplateMark: false, // 页面是否含有vip社区模板付费形状
        vipShapeNum: false, // 页面是否触发了60上限
        vipMath: false, // 页面是否使用了公式
        vipPPTFont: false, // 页面是否使用了资源库ppt文字
        // removeGrid: false, // 网格状态存储于ui.ts

        // page item
        vipPageTheme: false, // 页面主题
        vipPageColor: false, // 页面颜色
        vipPageConnect: false, // 页面连接线
        vipPageAutoBeautify: false, // 一键美化
        vipPageBackground: false, // 使用背景色
        vipDoctWatermark: false, // 页面水印
        vipDocPageNum: false, // 页面数
    },
    getters: {
        isUsedVipState: (state) => {
            return (
                state.vipSymbolMark ||
                state.vipTemplateMark ||
                state.cummunityVipTemplateMark ||
                state.vipShapeNum ||
                state.vipMath ||
                state.vipPPTFont ||
                state.vipPageTheme ||
                state.vipPageColor ||
                state.vipPageConnect ||
                state.vipPageAutoBeautify ||
                state.vipPageBackground ||
                state.vipDoctWatermark ||
                state.vipDocPageNum
            );
        },
        isOnlyVipSymbol: (state) => {
            return (
                state.vipSymbolMark &&
                !state.vipTemplateMark &&
                !state.cummunityVipTemplateMark &&
                !state.vipShapeNum &&
                !state.vipMath &&
                !state.vipPPTFont &&
                !state.vipPageTheme &&
                !state.vipPageColor &&
                !state.vipPageConnect &&
                !state.vipPageAutoBeautify &&
                !state.vipPageBackground &&
                !state.vipDoctWatermark &&
                !state.vipDocPageNum
            );
        },
        vipStateFuncList: (state) => {
            let list = [];
            if (state.vipSymbolMark) {
                list.push("funcSymbol");
            }
            if (state.vipTemplateMark || state.cummunityVipTemplateMark) {
                list.push("funcTemplate");
            }
            if (state.vipShapeNum) {
                list.push("funcShapeNum");
            }
            if (state.vipPageTheme) {
                list.push("funcPageTheme");
            }
            if (state.vipPageColor) {
                list.push("funcPageColor");
            }
            if (state.vipPageConnect) {
                list.push("funcPageConnect");
            }
            if (state.vipPageAutoBeautify) {
                list.push("funcAutoBeautify");
            }
            if (state.vipPageBackground) {
                list.push("funcPageBackground");
            }
            if (state.vipDoctWatermark) {
                list.push("funcDocWatermark");
            }
            if (state.vipDocPageNum) {
                list.push("funcDocNum");
            }
            if (state.vipMath) {
                list.push("funcShapeMath");
            }
            if (state.vipPPTFont) {
                list.push("funcShapePPT");
            }
            return list;
        },
        // vipStateBenefit: (state) => {
        //     let list = [];
        //     if(state.vipSymbolMark) {
        //         list.push(["funcSymbol"])
        //     }
        //     if(state.vipTemplateMark || state.cummunityVipTemplateMark) {
        //         list.push(["vipTemplate"])
        //     }
        //     if(state.vipShapeNum) {
        //         list.push(["symbolsExceedLimit"])
        //     }
        //     return list;
        // },
    },
    mutations: {
        setVipState(state, obj) {
            state[obj.type] = obj.data;
        },
    },
};
